import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';

const Header = () => {
  // Navigation now handles routing to /signin instead of opening modal
  const handleSignInClick = () => {
    // This is now handled by the Navigation component via Link
  };

  return (
    <header className="bg-background/95 backdrop-blur-sm border-b-[0.5px] border-border sticky top-0 z-40 px-0 py-[15px]">
      <div className="container mx-auto py-[2px] my-0 px-[2px]">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/logo1.png" 
              alt="Safurra - Protection, without pressure" 
              className="max-h-16 w-auto" 
              loading="eager"
              width="262"
              height="64"
            />
          </Link>

          {/* Navigation */}
          <div className="flex items-center space-x-8 min-w-[146px]">
            <Navigation onSignInClick={handleSignInClick} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;